module.exports = {
	"classes": [
		"about",
		"header"
	],
	"title": "About Auth0",
	"metas": {
		"description": "Auth0 solves the most complex and large-scale identity use cases for global enterprises with our extensible and easy-to-integrate platform."
	},
	"opengraph": {},
	"twittercard": {
		"twitter:title": "About our company - Auth0",
		"twitter:description": "Auth0 solves the most complex and large-scale identity use cases for global enterprises with our extensible and easy-to-integrate platform.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/assets/pages/about/img/twitter-card-118334b39d.png"
			}
		]
	},
	"canonical": "/about"
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/data/metadata.json
// module id = 1354
// module chunks = 0